import api from './axios';

// Mine (employee viewing their own IDPs) — never auto-creates anything
export async function listMyIdps(params = {}) {
    // { contract, data: [idps...], meta: {...} } OR 404 { code: 'no_contract' }
    const { data } = await api.get('/api/idps/mine', { params });
    return data;
}

// Managed (manager’s direct reports summary)
export async function listManagedIdps(params = {}) {
    // { data: [{ user, contract, idp_count, has_contract }...], meta: {...} }
    const { data } = await api.get('/api/idps/managed', { params });
    return data;
}

// CRUD
export async function showIdp(id) {
    const { data } = await api.get(`/api/idps/${id}`);
    return data;
}

export async function createIdp(payload) {
    // employee only: { contract_id, development_objective, competency_addressed, action_steps?, success_measures?, target_completion_date? }
    const { data } = await api.post('/api/idps', payload);
    return data?.data ?? data;
}

export async function updateIdpOwner(id, payload) {
    // employee can update only non-manager fields
    const { data } = await api.put(`/api/idps/${id}`, payload);
    return data?.data ?? data;
}

export async function updateIdpManager(id, payload) {
    // manager can update: { manager_support?, date_of_next_meeting? } only
    const { data } = await api.put(`/api/idps/${id}`, payload);
    return data?.data ?? data;
}

export async function deleteIdp(id) {
    const { data } = await api.delete(`/api/idps/${id}`);
    return data;
}

// List IDPs for a specific contract (manager or owner)
export async function listIdpsByContract(contractId, params = {}) {
    const { data } = await api.get(`/api/contracts/${contractId}/idps`, { params });
    return data; // { contract, data: [...], meta: ... }
}

export async function getIdp(id){ const {data}=await api.get('/api/idps/'+id); return data; }

